import type { BuildAddedCircuitNames } from "./types";
import type { CircuitKeyMap } from "../circuitKeys";
import type { CircuitBreakerMap } from "../circuitBreakers";

/**
 * The two names a created run answers to, published by the same rule the
 * estimation's own runs follow: the printed tag LEADS and the breaker rides
 * under it (KARL.md, `circuitBreakers/`).
 *
 * A breaker that normalises to the tag itself is not published at all — the
 * common case for a way he typed in by hand, where the id IS the designator.
 */
const normalize = (value: string): string =>
  value.toUpperCase().replace(/[^A-Z0-9]/g, "");

export const buildAddedCircuitNames: BuildAddedCircuitNames = ({ circuits }) => {
  const keys: CircuitKeyMap = {};
  const breakers: CircuitBreakerMap = {};
  for (const [circuitId, circuit] of Object.entries(circuits)) {
    keys[circuitId] = circuit.key;
    const breaker = circuit.breaker?.trim();
    if (breaker && normalize(breaker) !== normalize(circuit.key)) {
      breakers[circuitId] = breaker;
    }
  }
  return { keys, breakers };
};
